/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import {
  Box,
  Input /* The above code is a comment in JavaScript. It is not doing anything in terms of
functionality, but it is used to provide information or explanations about the
code to other developers. */,
  Typography,
} from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import Footer from "./footer";


const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    taxType: {
      type: "",
      value: "thuế giá trị gia tăng (GTGT)",
      bg: true,
      // option: taxTypeOption,
    },
    from: {
      type: "",
      value: "01/02/2023",
      bg: true,
    },
    to: {
      type: "",
      value: "01/03/2023",
      bg: true,
    },
    overPayment: {
      type: "input",
      value: 0,
      bg: false,
    },
    TTDBTax: {
      type: "input",
      value: 0,
      bg: false,
    },
    proposedPayment: {
      type: "input",
      value: 0,
      bg: false,
    },
    why: {
      type: "input",
      value: "Hoàn thuế TTĐB đối với xăng sinh học",
      bg: true,
    },
    mark: {
      type: "input",
      value: null,
      bg: false,
    },
    rules: {
      type: "input",
      value: null,
      bg: false,
    },
    clause: {
      type: "input",
      value: null,
      bg: false,
    },
    belongTo: {
      type: "input",
      value: null,
      bg: false,
    },
  },
];

export default function RefundTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" flexDirection={"column"} justifyContent="flex-start">
        <Typography component="label" variant="caption" fontSize={14} fontWeight="bold" mb={0.5}>
          II - Nội dung đề nghị hoàn trả khoản thu ngân sách nhà nước (NSNN):
        </Typography>
        <Typography variant="subtitle1" fontSize={13} fontStyle="normal">
          1. thông tin về khoản thu đề nghị hoàn trả
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Loại thuế
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                Kỳ đệ nghị hoàn
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền thuế nộp thừa (tính đến thời điểm đề nghị hoàn trả )
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TTĐB của xăng khoáng nguyên liệu đã đề nghị hoàn trả trên tờ khai thuế TTĐB
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền đề nghị hoàn trả
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", width: "20%" }}>
                Lý do đề nghị hoàn trả
              </Td>
              <Td colSpan={4} style={{ textAlign: "center" }}>
                Theo quy định tại
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Từ kỳ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Đến kỳ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Điểm
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Khoản
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Điều
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Của
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (5)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (6)
              </Td>
              <Td colSpan={5} style={{ textAlign: "center" }}>
                (7)
              </Td>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "#ddeff3",
                    }}
                  >
                    {index + 1}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxType.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxType?.type !== "input" ? (
                      row.taxType.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="taxType"
                        value={row.taxType.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.from.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.from?.type !== "input" ? (
                      row.from.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="from"
                        value={row.from.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.to.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.to?.type !== "input" ? (
                      row.to.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="to"
                        value={row.to.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.overPayment.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.overPayment?.type !== "input" ? (
                      row.overPayment.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="overPayment"
                        value={row.overPayment.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.TTDBTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.TTDBTax?.type !== "input" ? (
                      row.TTDBTax.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="TTDBTax"
                        value={row.TTDBTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.proposedPayment.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.proposedPayment?.type !== "input" ? (
                      row.proposedPayment.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="proposedPayment"
                        value={row.proposedPayment.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.why.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.why?.type !== "input" ? (
                      row.why.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="why"
                        value={row.why.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.mark.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.mark?.type !== "input" ? (
                      row.mark.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="mark"
                        value={row.mark.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.rules.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.rules?.type !== "input" ? (
                      row.rules.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="rules"
                        value={row.rules.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.clause.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.clause?.type !== "input" ? (
                      row.clause.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="clause"
                        value={row.clause.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.belongTo.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.belongTo?.type !== "input" ? (
                      row.belongTo.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="belongTo"
                        value={row.belongTo.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Td
                colspan="4"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
